import { Directive, HostListener } from '@angular/core';
import { WizardService } from './wizard.service';

@Directive({
	selector: '[pgsNextStep]'
})
export class NextStepDirective {

	constructor(private wizardService: WizardService) { }

	@HostListener('click')
	onClick(): void {
		this.wizardService.nextStep();
	}
}
